import { Rate } from "antd";
import React from "react";
import ViewRatings from "../Model/ViewRatings";

const RatingPanel = ({ Rating, type, id }) => {
  return (
    <div className="sideItem">
      <h1 className="timelineAboutpadding">Rating</h1>
      <div style={{ display: "flex", alignItems: "center", fontSize: "20px", fontWeight: "500" }}>
        {parseFloat(Rating || 0).toFixed(1)}
        <Rate
          disabled
          allowHalf
          value={Rating || 0}
          defaultValue={Rating || 0}
          style={{ fontSize: "30px", marginLeft: "10px" }}
        />
        {type && id ? <ViewRatings type={type} id={id} /> : null}
      </div>
    </div>
  );
};

export default RatingPanel;
